"use client";

import "@monsterindia/global-ui-components/dist/styles.css";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import React, { memo, useEffect, useState } from "react";

import { fetchHeaderNavLinks } from "../query";
import { HeaderLinksProps } from "../types";

const Header = dynamic<HeaderProps>(
  () => import("@monsterindia/seeker-jobs").then((mod) => mod.Header),
  {
    ssr: false,
  },
);

type HeaderProps = {
  headerData?: HeaderLinksProps[];
  host: string;
  isLoggedIn: boolean;
  isMobile: boolean;
  hamburgerData?: {
    mainLinkData?: HeaderDataType[];
    secondaryLinkData?: HeaderDataType[];
    quickLinkData?: HeaderDataType[];
  } | null;
  pathName?: string;
  headerParam?: string;
};
const HeaderSeekerJobs: React.FC<HeaderProps> = ({
  host,
  isLoggedIn,
  isMobile,
  hamburgerData,
  headerParam,
}) => {
  const pathName = usePathname() || "";

  const [navLinks, setNavLinks] = useState<HeaderLinksProps[]>([]);

  useEffect(() => {
    const fetchHeaderData = async () => {
      const { navLinks } = await fetchHeaderNavLinks();
      setNavLinks(navLinks);
    };
    fetchHeaderData();
  }, []);

  return (
    <Header
      headerData={navLinks}
      host={host}
      isLoggedIn={isLoggedIn}
      isMobile={isMobile}
      hamburgerData={hamburgerData}
      pathName={pathName}
      headerParam={headerParam}
    />
  );
};

export default memo(HeaderSeekerJobs);
